import ICarrierData from '../types/Carriers';
import { CarrierColor } from './constants';

/**
 * Filter out specified carrier codes from a list of carriers
 * 
 * @param carriers - The array of carrier data to filter
 * @param excludeCodes - Array of carrier codes to exclude (default: ['AS', 'QX'])
 * @returns Filtered array of carrier data
 */
export const partnerCarriers = (
  carriers: ICarrierData[], 
  excludeCodes: string[] = ['AS', 'QX']
): ICarrierData[] => {
  // Create a normalized version of exclude codes (trimmed)
  const normalizedExcludeCodes = excludeCodes.map(code => code.trim());
  
  return carriers.filter(carrier => {
    // Normalize the carrier code by trimming whitespace
    const normalizedCarrierCode = carrier.carrierCode.trim();
    
    // Check if the normalized carrier code is in the exclude list
    return !normalizedExcludeCodes.includes(normalizedCarrierCode);
  });
};

export const getCarrierColor = (operatingCarrier: string, flightTypeDescription: string): string => {
  // Check for Amazon flights first (applies to any carrier)
  if (flightTypeDescription.toLowerCase().includes('amazon')) {
    return CarrierColor.AMAZON;
  }

  if (operatingCarrier === 'AS') {
    if (flightTypeDescription.toLowerCase().includes('hawaii')) {
      return CarrierColor.HA; // purple for HA
    } else {
      return CarrierColor.AS;
    }
  } else if (operatingCarrier === 'QX') {
    return CarrierColor.QX;
  } else if (operatingCarrier === 'OO') {
    return CarrierColor.OO;
  } else {
    return CarrierColor.DEFAULT;
  }
};